module.exports = __webpack_public_path__ + "dist/static/media/warning.1293c447.svg";